var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#FFC048"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6611 51.0723C29.7497 50.2096 29.2939 49.1517 29.2939 47.8984C29.2939 46.6452 29.7497 45.6035 30.6611 44.7734C31.5889 43.9271 32.7038 43.5039 34.0059 43.5039C35.2917 43.5039 36.3822 43.9271 37.2773 44.7734C38.1888 45.6035 38.6445 46.6452 38.6445 47.8984C38.6445 49.168 38.1888 50.2259 37.2773 51.0723C36.3822 51.9186 35.2917 52.3418 34.0059 52.3418C32.7038 52.3418 31.5889 51.9186 30.6611 51.0723ZM29.1963 21.3115H38.7422L37.0088 41.6973H30.9541L29.1963 21.3115Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningicon);
export default __webpack_public_path__ + "static/media/warningicon.6feec311b9f3491d3603a3bfac4f93dd.svg";
export { ForwardRef as ReactComponent };